import {
  ControlsHeight,
  ControlsHeightContext,
} from '@jetbrains/ring-ui/components/global/controls-height'
import {PopupTarget} from '@jetbrains/ring-ui/components/popup/popup'
import type {FunctionComponent} from 'react'
import React, {useMemo} from 'react'
import {Outlet} from 'react-router-dom'

import Feedback from './components/common/Feedback/Feedback'
import {pipelinesAppId} from './PipelinesPages.consts'
import usePipelinesPages from './PipelinesPages.hooks'

import styles from './PipelinesPages.css'

const PipelinesPages: FunctionComponent = () => {
  usePipelinesPages()

  return useMemo(
    () => (
      <ControlsHeightContext.Provider value={ControlsHeight.S}>
        <div className={styles.app} id={pipelinesAppId}>
          <PopupTarget id={pipelinesAppId}>
            <Outlet />
          </PopupTarget>
        </div>
        <Feedback />
      </ControlsHeightContext.Provider>
    ),
    [],
  )
}

export default PipelinesPages
